import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

const FreshdeskIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox={'0 0 65 65'}>
        <g stroke="none" fillRule="nonzero">
            <path
                d="M31.9 0h24.036a8 8 0 0 1 5.724 2.346A8 8 0 0 1 64 8.073V32.1C64 49.722 49.722 64 32.1 64h-.182A31.89 31.89 0 0 1 0 32.109C0 14.437 14.254.182 31.9 0z"
                fill="#25c16f"
            />
            <path d="M31.9 14.255c-8.093 0-14.654 6.56-14.654 14.654v9.964c.058 2.667 2.206 4.815 4.873 4.873h4.145V32.3h-5.6v-3.2c.34-6.026 5.327-10.74 11.364-10.74S43.04 23.065 43.38 29.1v3.2H37.7v11.454h3.745v.182c-.04 2.474-2.035 4.47-4.5 4.5h-4.473c-.364 0-.764.182-.764.545a.8.8 0 0 0 .764.764h4.5c3.205-.02 5.798-2.613 5.818-5.818v-.364a4.8 4.8 0 0 0 3.745-4.727V29.1c.182-8.254-6.364-14.836-14.654-14.836z" />
        </g>
    </SvgIcon>
);

export default FreshdeskIcon;
